import Vue from 'vue';
import InvoiceInfoCard from './cards/info/InvoiceInfoCard';
import InvoiceFacilityBillable from './cards/billable/InvoiceFacilityBillable';
import InvoiceProviderPayable from './cards/payable/InvoiceProviderPayable';
import {UserRoleEnum} from '@/enums/userRolesEnum';
import InvoiceSpecialNotes from './cards/special/InvoiceSpecialNotesCard';
import PotentialInvoiceDetailsCard from './cards/potentialDetails/PotentialInvoiceDetailsCard';
import PotentialInvoiceTotalsCard from './cards/potentialTotals/PotentialInvoiceTotalsCard';
import InvoiceChecklistCard from './cards/checklist/InvoiceChecklistCard';
import {AppEntityType} from "@/enums/AppEntityType";
import NotesCard from "@/componentsReusable/cards/NotesCard";
import AttachmentsCard from "@/componentsReusable/cards/AttachmentsCard";

export default Vue.extend({
  name: 'MergedInvoice',
  props: {
    'mergedInvoiceId': { type: [String, Number] },

  },
  components: {
    InvoiceFacilityBillable,
    InvoiceProviderPayable,
    InvoiceInfoCard,
    NotesCard,
    AttachmentsCard,
    InvoiceSpecialNotes,
    InvoiceChecklistCard,
    PotentialInvoiceDetailsCard,
    PotentialInvoiceTotalsCard
  },
  data () {
    return {
      isAuthorized: false,
      invoiceInfo: null as any,
      noteEntityType: AppEntityType.MERGED_INVOICE_NOTE,
      attachmentEntityType: AppEntityType.MERGED_INVOICE_ATTACHMENT
    };
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole']([
      UserRoleEnum.MANAGER,
      UserRoleEnum.ACCOUNTANT
    ]);
  },
  methods: {
    invoiceInfoLoaded (invoiceInfo: any) {
      this.invoiceInfo = invoiceInfo;
      if (invoiceInfo && invoiceInfo.invoiceId > 0) {
        this.$router.push({ name: 'Invoice', params: { invoiceId: invoiceInfo.invoiceId }});
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoice/MergedInvoice.ts